var map = {
	"./core/Footer.vue": "7a74",
	"./core/Navigation.vue": "2aeb",
	"./core/Toolbar.vue": "d23b",
	"./features/HelpModal.vue": "916b",
	"./features/diagrams/BarDiagram.vue": "7a8b",
	"./features/diagrams/PieChart.vue": "f413",
	"./features/diagrams/PieDiagram.vue": "f62e",
	"./features/diagrams/RadarChart.vue": "82c3",
	"./features/diagrams/RadarDiagram.vue": "7d6d",
	"./features/diagrams/ScatterChart.vue": "66e9",
	"./features/diagrams/ScatterDiagram.vue": "aecd",
	"./features/diagrams/StackedBarChart.vue": "a0c8",
	"./features/test/Charts.vue": "e40f",
	"./features/test/Overview.vue": "8730",
	"./features/test/Questions.vue": "8cb6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ffe0";